import { AxiosError, AxiosResponse } from 'axios';

interface SuccessResponse<T = unknown> {
  type: 'success';
  data: T;
}
interface ErrorResponse {
  type: 'error';
  status?: number;
  error: { errors: string[] };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type ApiResponse<T = any> = SuccessResponse<T> | ErrorResponse;

export const transformSuccess = <T>({ data, ...rest }: AxiosResponse<T>): ApiResponse<T> => {
  return { ...rest, type: 'success', data: data };
};

export const transformError = ({ response, message }: AxiosError): ApiResponse => {
  if (message === 'canceled') {
    return { ...response, type: 'error', error: { errors: ['Canceled request'] } };
  }
  if (response?.status === 401) {
  } else if (response?.status === 500 || response?.status === 422) {
    return {
      ...response,
      type: 'error',
      error: { errors: [`Internal Server Error (${response.status})! Please try again later`] },
    };
  }

  return { ...response, type: 'error', error: (response?.data as { errors: string[] }) || { errors: [] } };
};
